module.exports = __webpack_public_path__ + "static/media/feature-more6.e373d876.png";